import moment from "moment";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import {
    UPDATE_COMPETITOR_DURATION_FILTER,
    SET_COMPETITOR_NAME,
    SET_COMPETITOR_PLATFORM,
    SET_COMPETITOR_LOCATION,
    SET_COMPETITOR_URL,
    SET_COMPETITOR_ENTITY,
    VALIDATE_COMPETITOR_ACCOUNT,
    SET_VALID_COMPETITOR_ACCOUNT,
    JOIN_COMPETITOR_ACCOUNT,
    CREATE_COMPETITOR_RULE,
    FETCH_COMPETITOR_LIST,
    // DELETE_COMPETITOR_ACCOUNT,
    SET_EDIT_COMPETITOR,
    FETCH_COMPETITOR_POSTS,
    SET_COMPETITOR_FILTER,
    SET_SELECTED_COMPETITORS,
    FETCH_COMP_TABLE_CHART_DATA,
    FETCH_COMPETITOR_POSTS_COUNT,
    FETCH_COMPETITOR_IMPACT_SCORE,
    SET_EXISTING_COMPETITOR_NAME,
} from "../actions/competitorInsightsActions";

const competitorInsightsReducer = (
    state = {
        durationFilter: {
            duration: "7",
            startDateTime: moment(new Date()).subtract(6, "days").startOf("day").format("YYYY-MM-DD"),
            endDateTime: moment(new Date()).format("YYYY-MM-DD"),
        },
        competitorName: "",
        existingCompetitorName: "",
        competitorPlatform: "",
        competitorLocation: "",
        competitorUrl: "",
        competitorEntity: "",
        isAccountValid: false,
        verifyingAccount: false,
        isRuleCreated: false,
        ruleCreatorLoading: false,
        joiningAccount: false,
        competitorList: [],
        competitorTable: { loading: false, data: null },
        apiLoading: false,
        competitorForEdit: {},
        competitorPostsList: { loading: false, data: [] },
        filterStatus: { text: "Platform", value: "" },
        selectedCompetitors: [],
        competitorByEngagements: {
            loading: false,
            data: null,
        },
        competitorPostCount: { loading: false, data: [] },
        competitorImpactScore: { loading: false, data: [] },
        competitorByHashtags: { loading: false, data: [] },
        competitorByFollowers: {
            loading: false,
            data: null,
        },
    },
    action,
) => {
    switch (action.type) {
        case UPDATE_COMPETITOR_DURATION_FILTER:
            return (state = {
                ...state,
                durationFilter: { ...state.durationFilter, ...action.payload },
            });
        case SET_COMPETITOR_NAME:
            return (state = {
                ...state,
                competitorName: action.payload,
            });
        case SET_EXISTING_COMPETITOR_NAME:
            return (state = {
                ...state,
                existingCompetitorName: action.payload || "",
            });
        case SET_COMPETITOR_PLATFORM:
            return (state = {
                ...state,
                competitorPlatform: action.payload,
            });
        case SET_COMPETITOR_LOCATION:
            return (state = {
                ...state,
                competitorLocation: action.payload,
            });
        case SET_COMPETITOR_URL:
            return (state = {
                ...state,
                competitorUrl: action.payload,
            });
        case SET_COMPETITOR_ENTITY:
            return (state = {
                ...state,
                competitorEntity: action.payload,
            });

        case SET_VALID_COMPETITOR_ACCOUNT:
            return (state = {
                ...state,
                isAccountValid: action.payload,
            });

        case SET_EDIT_COMPETITOR:
            return (state = {
                ...state,
                competitorForEdit: action.payload,
            });
        case SET_COMPETITOR_FILTER:
            return (state = {
                ...state,
                filterStatus: action.payload,
            });
        case SET_SELECTED_COMPETITORS:
            return (state = {
                ...state,
                selectedCompetitors: action.payload,
            });

        // case DELETE_COMPETITOR_ACCOUNT:
        //     return (state = {
        //         ...state,
        //         competitorEngagementList: [],
        //         competitorTable: [],
        //         competitorPostsList: [],
        //     });

        case isPending(FETCH_COMPETITOR_POSTS):
            return (state = {
                ...state,
                competitorPostsList: { loading: true, data: [] },
            });
        case isFulfilled(FETCH_COMPETITOR_POSTS): {
            return (state = {
                ...state,
                competitorPostsList: { loading: false, data: action.payload },
            });
        }
        case isRejected(FETCH_COMPETITOR_POSTS):
            return (state = {
                ...state,
                competitorPostsList: { loading: false, data: null },
            });

        case isPending(FETCH_COMPETITOR_POSTS_COUNT):
            return (state = {
                ...state,
                competitorPostCount: { loading: true, data: [] },
            });
        case isFulfilled(FETCH_COMPETITOR_POSTS_COUNT): {
            return (state = {
                ...state,
                competitorPostCount: { loading: false, data: action.payload },
            });
        }
        case isRejected(FETCH_COMPETITOR_POSTS_COUNT):
            return (state = {
                ...state,
                competitorPostCount: { loading: false, data: [] },
            });
        case isPending(FETCH_COMPETITOR_IMPACT_SCORE):
            return (state = {
                ...state,
                competitorImpactScore: { loading: true, data: [] },
            });
        case isFulfilled(FETCH_COMPETITOR_IMPACT_SCORE): {
            // console.log("testststs", action.payload);
            return (state = {
                ...state,
                competitorImpactScore: { loading: false, data: action.payload },
            });
        }
        case isRejected(FETCH_COMPETITOR_IMPACT_SCORE):
            return (state = {
                ...state,
                competitorImpactScore: { loading: false, data: [] },
            });

        case isPending("FETCH_COMPETITOR_BY_HASHTAGS"):
            return (state = {
                ...state,
                competitorByHashtags: { loading: true, data: [] },
            });
        case isFulfilled("FETCH_COMPETITOR_BY_HASHTAGS"): {
            return (state = {
                ...state,
                competitorByHashtags: { loading: false, data: action.payload },
            });
        }
        case isRejected("FETCH_COMPETITOR_BY_HASHTAGS"):
            return (state = {
                ...state,
                competitorByHashtags: { loading: false, data: [] },
            });

        case isPending("FETCH_COMPETITOR_BY_ENGAGEMENTS"):
            return (state = {
                ...state,
                competitorByEngagements: {
                    ...state.competitorByEngagements,
                    [action.payload]: {
                        loading: true,
                        data: null,
                    },
                },
            });
        case isFulfilled("FETCH_COMPETITOR_BY_ENGAGEMENTS"): {
            let newData = JSON.parse(JSON.stringify(action.payload));
            delete newData.query_id;

            return (state = {
                ...state,
                competitorByEngagements: {
                    ...state.competitorByEngagements,
                    [action.payload.query_id]: { loading: false, data: newData },
                },
            });
        }

        case isRejected("FETCH_COMPETITOR_BY_ENGAGEMENTS"):
            return (state = {
                ...state,

                competitorByEngagements: {
                    [action.payload]: { loading: false, data: null },
                },
            });

        case isPending("FETCH_COMPETITOR_FOLLOWERS"):
            return (state = {
                ...state,
                competitorByFollowers: {
                    ...state.competitorByFollowers,
                    [action.payload]: {
                        loading: true,
                        data: null,
                    },
                },
            });

        case isFulfilled("FETCH_COMPETITOR_FOLLOWERS"): {
            let newData = JSON.parse(JSON.stringify(action.payload));
            delete newData.query_id;

            return (state = {
                ...state,
                competitorByFollowers: {
                    ...state.competitorByFollowers,
                    [action.payload.query_id]: { loading: false, data: newData },
                },
            });
        }

        case isRejected("FETCH_COMPETITOR_FOLLOWERS"):
            return (state = {
                ...state,

                competitorByFollowers: {
                    [action.payload]: { loading: false, data: null },
                },
            });

        case isPending(FETCH_COMPETITOR_LIST):
            return (state = {
                ...state,
                apiLoading: true,
            });
        case isFulfilled(FETCH_COMPETITOR_LIST):
            return (state = {
                ...state,
                competitorList: action.payload,
                apiLoading: false,
            });
        case isRejected(FETCH_COMPETITOR_LIST):
            return (state = {
                ...state,
                apiLoading: false,
            });
        case isPending(FETCH_COMP_TABLE_CHART_DATA):
            return (state = {
                ...state,
                competitorTable: { loading: true, data: null },
            });
        case isFulfilled(FETCH_COMP_TABLE_CHART_DATA):
            return (state = {
                ...state,
                competitorTable: { loading: false, data: action.payload },
            });
        case isRejected(FETCH_COMP_TABLE_CHART_DATA):
            return (state = {
                ...state,
                competitorTable: { loading: false, data: null },
            });

        case isPending(VALIDATE_COMPETITOR_ACCOUNT):
            return (state = {
                ...state,
                verifyingAccount: true,
            });
        case isRejected(VALIDATE_COMPETITOR_ACCOUNT):
            return (state = {
                ...state,
                verifyingAccount: false,
            });
        case isFulfilled(VALIDATE_COMPETITOR_ACCOUNT):
            if (action.payload.status) {
                return (state = {
                    ...state,
                    isAccountValid: true,
                    verifyingAccount: false,
                });
            } else {
                return (state = {
                    ...state,
                    isAccountValid: false,
                    verifyingAccount: false,
                });
            }
        case isPending(CREATE_COMPETITOR_RULE):
            return (state = {
                ...state,
                isRuleCreated: false,
                ruleCreatorLoading: true,
            });
        case isRejected(CREATE_COMPETITOR_RULE):
            return (state = {
                ...state,
                isRuleCreated: false,
                ruleCreatorLoading: false,
            });
        case isFulfilled(CREATE_COMPETITOR_RULE):
            return (state = {
                ...state,
                isRuleCreated: true,
                ruleCreatorLoading: false,
            });
        case isPending(JOIN_COMPETITOR_ACCOUNT):
            return (state = {
                ...state,
                joiningAccount: true,
            });
        case isRejected(JOIN_COMPETITOR_ACCOUNT):
            return (state = {
                ...state,
                joiningAccount: false,
            });
        case isFulfilled(JOIN_COMPETITOR_ACCOUNT):
            return (state = {
                ...state,
                joiningAccount: false,
            });
        default:
            return state;
    }
};

export default competitorInsightsReducer;
